// Donor/signatory field rules, shared by every page that asks for them.
//
// These five rules were copied verbatim into DonatePage, JoinPage and
// CampaignPage — the comment above one of the copies even said "identical rules
// to the donate/join pages". A phone number accepted on the donate page has to
// be accepted on the petition page too, and three copies is three chances for
// that to stop being true.
//
// Only the genuinely shared parts live here. What each page asks for on top —
// JoinPage's address and academic institution, the foreign-currency address
// fields that only apply when IsraelGives demands them — stays with the page,
// because those lists really do differ.

// Rules are { key, pattern, customTest?, skip?, message }:
//   pattern     must match the trimmed-to-string value
//   customTest  extra predicate when a regex can't say it (see phone)
//   skip        (form) => true to not validate this field for this form state
export const FIELD_RULES = {
  firstName: {
    key: 'firstName',
    pattern: /^\D{2,}$/,
    message: 'יש להזין שם פרטי يرجى اضافة الاسم للشخصي',
  },
  lastName: {
    key: 'lastName',
    pattern: /^\D{2,}$/,
    message: 'יש להזין שם משפחה يرجى اضافة اسم العائلة',
  },
  city: {
    key: 'city',
    pattern: /^.{2,}$/,
    message: 'יש להזין יישוב מגורים يرجى اضافة مكان السكنى',
  },
  phone: {
    key: 'phone',
    pattern: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{1,3})?[-. )]*(\d{2,3})[-. ]*(\d{1,4})(?:\s*(\d+))?[-. ]*(\d{2,4})\s*$/,
    // The pattern alone accepts too little to be a phone number; nine digits is
    // the floor for an Israeli one.
    customTest: (v) => (v.match(/\d/g) || []).length >= 9,
    message: 'יש להזין מספר טלפון תקין يرجى اضافة رقم هاتف من صحيح',
  },
  email: {
    key: 'email',
    pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: 'יש להזין כתובת אימייל תקינה يرجى اضافة بريد الكتروني صحيح',
  },
};

// True when `value` satisfies `rule`. Empty counts as failing — required-ness is
// the caller's business, not the rule's.
export function isValid(rule, value) {
  const v = value || '';
  return rule.pattern.test(v) && (!rule.customTest || rule.customTest(v));
}

// { key: message } for every rule that fails. Empty object = the form is valid.
// `rules` is the page's own composed list, so each page keeps control of which
// fields it asks for and when.
export function validateForm(form, rules) {
  const errors = {};
  for (const rule of rules) {
    if (rule.skip && rule.skip(form)) continue;
    if (!isValid(rule, form[rule.key])) errors[rule.key] = rule.message;
  }
  return errors;
}
